<template>
  <div>
    <Form
      ref="formData" :model="tortSubjectObj"
      :label-width="labelWidth"
    >
      <Row>
        <FormItem label="主体类型" prop="type">
          <RadioGroup v-model="tortSubjectObj.category" @on-change="changeCategory">
            <Radio
              v-for="(tortTypeItem, index) in tortSubjCategoryArr" :key="index"
              :label="tortTypeItem.value"
            >{{ tortTypeItem.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
      </Row>
      <Row>
        <FormItem
          v-if="tortSubjectObj.category == 'S'" label="经营性质"
          prop="property"
        >
          <RadioGroup v-model="tortSubjectObj.property">
            <Radio
              v-for="(tortPropertyItem, index) in tortSubjPropertyArr" :key="index"
              :label="tortPropertyItem.value"
            >{{ tortPropertyItem.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
      </Row>
      <Row>
        <Row>
          <FormItem
            v-if="tortSubjectObj.category=='M'" label="经营性质"
            prop="property"
          >
            <RadioGroup v-model="tortSubjectObj.property">
              <!-- <Radio v-for="(tortPropertyItem,index) in tortSubjPropertyProducerArr" :key="index" :label="tortPropertyItem.value" :disabled="(Object.keys(defaultData).length === 0 && tortPropertyItem.nameZh !== '个人' ) || Object.keys(defaultData).length !== 0">{{ tortPropertyItem.nameZh }}</Radio> -->
              <Radio
                v-for="(tortPropertyItem,index) in tortSubjPropertyProducerArr" :key="index"
                :label="tortPropertyItem.value"
              >
                {{ tortPropertyItem.nameZh }}
              </Radio>
            </RadioGroup>
          </FormItem>
        </Row>
        <!-- :rules="
            notRequire && tortSubjectObj.category == 'S'
              ? [longLimit]
              : [
                  {
                    required: true,
                    message: '主体名称不能为空',
                    trigger: 'blur'
                  },
                  longLimit
                ]
          " -->
        <FormItem
          label="主体名称" prop="name"
          :rules="notRequire && tortSubjectObj.category == 'S' ? [longLimit] : [{required:true,message:'主体名称不能为空', trigger:'blur'},longLimit]"
        >
          <tianyancha
            v-if="isDetailLoad" :default-name="tortSubjectObj.name"
            :style="{
              display: 'inline-block',
              width:
                tortSubjectObj.property != 'P' && tortSubjectObj.name
                  ? '80%'
                  : '100%'
            }" @getCustomerName="getTortSubjectInfo($event)"
          />
          <Button
            v-if="tortSubjectObj.property != 'P' && tortSubjectObj.name" title="点击核对对方当事人信息"
            @click="getParty"
          >核对</Button>
          <span v-if="isShowWhite" class="warn">该线索报备店铺为授权店</span>
          <span v-if="isShowSupplier" class="warn">该主体已被其他单位打击</span>
        </FormItem>
      </Row>
      <Row v-if="tortSubjectObj.category == 'S'">
        <FormItem label="主体标签" prop="type">
          <RadioGroup v-model="tortSubjectObj.type">
            <Radio
              v-for="(tortTypeItem, index) in tortSubjTypeArr" :key="index"
              :label="tortTypeItem.value"
            >{{ tortTypeItem.nameZh }}</Radio>
          </RadioGroup>
        </FormItem>
      </Row>
      <Row>
        <FormItem
          key="creditCode"
          :label="
            tortSubjectObj.property != 'P' || tortSubjectObj.category == 'M'
              ? '信用代码'
              : '身份证号'
          " prop="creditCode"
          :rules="CreditCodeValid "
        >
          <Input
            v-model.trim="tortSubjectObj.creditCode" :placeholder="
              '请输入' +
                (tortSubjectObj.property != 'P' ||
                  tortSubjectObj.category == 'M'
                  ? '信用代码'
                  : '身份证号')
            "
          />
        </FormItem>
      </Row>

      <Row
        v-if="
          tortSubjectObj.category === 'M' &&
            tortSubjectObj.platformOrderNo &&
            tortCategory === 2
        "
      >
        <FormItem label="订单号">
          <Input :value="tortSubjectObj.platformOrderNo" disabled />
        </FormItem>
      </Row>
      <Row v-if="tortSubjectObj.category === 'S' && tortCategory === 2">
        <FormItem
          label="订单号" prop="platformOrderNo"
          :rules="orderNoValid"
        >
          <Input v-model.trim="tortSubjectObj.platformOrderNo" placeholder="请输入订单号" />
        </FormItem>
      </Row>

      <Row v-if="tortSubjectObj.property!='P' && tortSubjectObj.property!= undefined && tortSubjectObj.property!= 'I'">
        <FormItem
          :label="$t('property.'+tortSubjectObj.property)" prop="legalRepresentative"
          :rules="(notRequire && tortSubjectObj.category!='M')?[longLimit]:[{required: true, message: $t('property.'+ tortSubjectObj.property)+'不能为空', trigger: 'blur' }]"
        >
          <Input v-model.trim="tortSubjectObj.legalRepresentative" :placeholder="'请输入'+$t('property.'+tortSubjectObj.property)" />
        </FormItem>
      </Row>

      <Row v-else-if="tortSubjectObj.property!='I' && tortSubjectObj.property!='P' ">
        <FormItem
          :label="$t('property.'+'E')" prop="legalRepresentative"
          :rules="(notRequire && 'E' !='M')?[longLimit]:[{required: true, message: $t('property.'+'E')+'不能为空', trigger: 'blur'}]"
        >
          <Input v-model.trim="tortSubjectObj.legalRepresentative" :placeholder="'请输入'+$t('property.'+'E')" />
        </FormItem>
      </Row>

      <Row v-if="tortSubjectObj.property== 'I'">
        <FormItem
          label="经营者" prop="legalRepresentative"
          :rules="(notRequire && tortSubjectObj.category!='M')?[longLimit]:[{required: true, message: '经营者不能为空', trigger: 'blur' }]"
        >
          <Input v-model.trim="tortSubjectObj.legalRepresentative" :placeholder="'请输入'+$t('property.'+tortSubjectObj.property)" />
        </FormItem>
      </Row>

      <Row v-if="$t('property.' + tortSubjectObj.property) === '经营者'">
        <FormItem
          label="经营者身份证号" prop="legalIdNo"
          :rules="[
            {
              pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
              message: '身份证格式错误',
              trigger: 'blur'
            }
          ]"
        >
          <Input v-model.trim="tortSubjectObj.legalIdNo" placeholder="请输入经营者身份证号" />
        </FormItem>
      </Row>
      <Row v-if="tortSubjectObj.category == 'M' && tortSubjectObj.property == 'E' ">
        <FormItem
          label="法定代表人身份证" prop="legalIdNo"
          :rules="[
            {
              pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
              message: '身份证格式错误',
              trigger: 'blur'
            }
          ]"
        >
          <Input v-model.trim="tortSubjectObj.legalIdNo" placeholder="请输入法定代表人身份证号" />
        </FormItem>
      </Row>
      <!-- 案件详情--新增当事人才会显示该字段 -->
      <Row v-if="identifyShow">
        <FormItem
          label="联系方式" prop="contact"
          :rules="
            tortSubjectObj.property != 'P'
              ? [{}]
              : [
                {
                  required: true,
                  message: '联系方式不能为空',
                  trigger: 'blur'
                }
              ]
          "
        >
          <Input v-model.trim="tortSubjectObj.contact" placeholder="请输入联系方式" />
        </FormItem>
      </Row>
      <!-- 线索报备才会显示 -->
      <Row v-else>
        <FormItem label="联系方式" prop="contact">
          <Input v-model.trim="tortSubjectObj.contact" placeholder="请输入联系方式" />
        </FormItem>
      </Row>
      <Row>
        <FormItem
          label="主体区域" prop="province"
          :rules="
            notRequire && tortSubjectObj.category != 'M'
              ? {}
              : { required: true, message: '主体区域不能为空', trigger: 'blur' }
          "
        >
          <City
            v-if="isDetailLoad" ref="transEvent"
            :city-list="tortSubjectObj.cityList || []" style="width:100%;"
            @listenCity="getCity($event, 'clueTortSubjectList')"
          />
        </FormItem>
      </Row>
      <Row>
        <FormItem
          label="工商登记地址" prop="address"
          :rules="
            notRequire && tortSubjectObj.category != 'M'
              ? [longLimit]
              : [
                {
                  required: true,
                  message: '工商登记地址不能为空',
                  trigger: 'blur'
                },
                longLimit
              ]
          "
        >
          <Input
            v-model.trim="tortSubjectObj.address" type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入工商登记地址"
          />
        </FormItem>
      </Row>
      <Row v-if="identifyShow">
        <FormItem
          label="认定依据图片" prop="attachmentList"
          :rules="
            tortSubjectObj.category == 'M'
              ? {
                required: true,
                type: 'array',
                message: '认定依据图片不能为空',
                trigger: 'change'
              }
              : { type: 'array' }
          "
        >
          <file-upload :default-list="tortSubjectObj.attachmentList || []" @getFileList="getAttachmentList($event)" />
        </FormItem>
        <FormItem
          label="认定依据描述" prop="identifyRemark"
          :rules="
            tortSubjectObj.category == 'M'
              ? {
                required: true,
                message: '认定依据描述不能为空',
                trigger: 'blur'
              }
              : {}
          "
        >
          <Input
            v-model.trim="tortSubjectObj.identifyRemark" type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }" placeholder="请输入认定依据描述"
          />
        </FormItem>
      </Row>
    </Form>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    notRequire: {
      type: Boolean,
      default: false
    },
    defaultData: {
      type: Object | String
    },
    labelWidth: {
      type: Number,
      default: 150
    },
    formValidate: {
      type: Object
    },
    identifyShow: {
      type: Boolean,
      default: false
    },
    tortCategory: {
      // 线上：2、线下：1
      type: Number,
      default: 0
    },
    channelType: {
      // 平台类型：淘宝/拼多多/小红书。。。
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tortSubjPropertyArr: [],
      tortSubjPropertyProducerArr: [],
      tortSubjTypeArr: [],
      tortSubjCategoryArr: [],
      isDetailLoad: false,
      initProperty: '', // tortSubjectObj.property初始的值
      isShowWhite: false,
      isShowSupplier: false,
      tortSubjectObj: {
        category: 'S',
        property: 'E',
        name: '',
        type: 'E',
        creditCode: '',
        platformOrderNo: '', // 订单号
        legalIdNo: '', // 经营者身份证号
        legalRepresentative: '',
        address: '',
        province: '',
        city: '',
        area: '',
        contact: '',
        attachmentList: [],
        identifyRemark: ''
      },
      longLimit: { max: 100, message: '不能超过100个字符', trigger: 'blur' }
    }
  },
  computed: {
    IDCardValid() {
      if (
        this.tortCategory === 2 /* 线上 */ &&
        this.channelType === 'PD' /*  拼多多 */
      ) {
        return [
          { required: true, message: '身份证号必填', trigger: 'blur' },
          {
            pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '身份证格式错误',
            trigger: 'blur'
          }
        ]
      } else {
        return [
          {
            pattern: /^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: '身份证格式错误',
            trigger: 'blur'
          }
        ]
      }
    },
    CreditCodeValid() {
      if (this.tortSubjectObj.property == 'P') {
        return this.IDCardValid
      } else if (this.notRequire) {
        if (this.tortSubjectObj.category == 'S') {
          return [this.longLimit]
        } else {
          return [{ required: true, message: '信用代码不能为空', trigger: 'blur' }, this.longLimit]
        }
      } else {
        return [{ required: true, message: '信用代码不能为空', trigger: 'blur' }, this.longLimit]
      }
    },

    orderNoValid() {
      if (
        (this.channelType === 'PD' ||
        this.channelType === 'TT') &&
        !this.defaultData.id /*  拼多多或淘宝 */
      ) {
        return [
          {
            type: 'string',
            required: true,
            message: '订单号不可为空',
            trigger: 'blur'
          },
          { max: 64, message: '长度不能超过64位', trigger: 'blur' }
        ]
      } else {
        return [
          {
            type: 'string',
            max: 64,
            message: '长度不能超过64位',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    tortSubjectObj: {
      handler(val, oldVal) {
        setTimeout(() => {
          this.submitValid()
        }, 50)
      },
      deep: true
    }
  },
  created() { },
  beforeMount() {
    this.getDictionary()
  },
  mounted() {
    if (this.defaultData && this.defaultData.id) {
      this.giveData()
    } else {
      this.isDetailLoad = true
    }
  },
  updated() { },
  methods: {
    getTortSubjectInfo(data) {
      this.tortSubjectObj.name = data.compayName ? data.compayName.trim() : ''
      this.tortSubjectObj.creditCode = data.creditCode // 身份证号
      this.tortSubjectObj.platformOrderNo = data.platformOrderNo || ''
      this.tortSubjectObj.contact = data.phoneNumber
        ? data.phoneNumber.trim()
        : ''
      if (this.tortSubjectObj.property != 'P') {
        this.tortSubjectObj.legalRepresentative = data.legalPersonName // 法定代表人||经营者
      }
      if (data.address) {
        this.tortSubjectObj.cityList = [
          data.address.provinceCode,
          data.address.cityCode,
          data.address.areaCode
        ]
        this.tortSubjectObj.address = data.address.text
        const name = 'transEvent'
        this.$nextTick(function () {
          this.$refs[name].uploadData()
        })
      }
      if (this.formValidate && this.formValidate.missionId) {
        this.whiteConflict()
      }
    },
    // 查询白名单冲突
    whiteConflict() {
      const url = '/business/mission/' + this.formValidate.missionId
      this.$get(url).then(res => {
        const url2 = '/business/roster/whitelist/conflict'
        const ajaxData = {
          projectId: res.data.projId,
          tortCategory:
            this.formValidate.tortType == 'E_EC' ||
              this.formValidate.tortType == 'E_WL'
              ? 2
              : 1,
          tortSubjectList: this.tortSubjectObj.name,
          platform: this.formValidate.channelType
        }
        if (this.tortSubjectObj.address) {
          ajaxData.address = this.tortSubjectObj.address
        }
        if (this.tortSubjectObj.province) {
          ajaxData.province = this.tortSubjectObj.province
        }
        if (this.tortSubjectObj.city) {
          ajaxData.city = this.tortSubjectObj.city
        }
        if (this.tortSubjectObj.area) {
          ajaxData.area = this.tortSubjectObj.area
        }
        this.$get(url2, ajaxData).then(res => {
          if (res.data) {
            // 说明有冲突 禁用按钮
            this.$emit('changeBtn', true)
            this.isShowWhite = true
          } else {
            this.isShowWhite = false
            this.$emit('changeBtn', false)
            this.supplierConflict()
          }
        })
      })
    },

    // 查询供应商冲突
    supplierConflict() {
      const url = '/business/mission/' + this.formValidate.missionId
      this.$get(url).then(res => {
        const url2 = '/business/roster/supplier/conflict'
        const ajaxData = {
          projectId: res.data.projId,
          tortCategory:
            this.formValidate.tortType == 'E_EC' ||
              this.formValidate.tortType == 'E_WL'
              ? 2
              : 1,
          tortSubjectList: this.tortSubjectObj.name,
          platform: this.formValidate.channelType
        }
        if (this.tortSubjectObj.address) {
          ajaxData.address = this.tortSubjectObj.address
        }
        if (this.tortSubjectObj.province) {
          ajaxData.province = this.tortSubjectObj.province
        }
        if (this.tortSubjectObj.city) {
          ajaxData.city = this.tortSubjectObj.city
        }
        if (this.tortSubjectObj.area) {
          ajaxData.area = this.tortSubjectObj.area
        }
        this.$get(url2, ajaxData).then(res => {
          if (res.data) {
            this.isShowSupplier = true
          } else {
            this.isShowSupplier = false
          }
        })
      })
    },

    // 查询当事人是否注销
    getParty() {
      const url = '/business/abnormal/enterprise'
      const ajaxData = {
        companyName: this.tortSubjectObj.name
      }
      this.$get(url, ajaxData).then(res => {
        if (res.code == 0) {
          // M.正常 N.查询不到 C.已注销
          if (res.data == 'N') {
            this.$Message.error('经比对，该当事人信息不在数据库中！')
          }
          if (res.data == 'C') {
            this.$Message.error('经比对，该当事人已注销!')
          }
          if (res.data == 'M') {
            this.$Message.success('该当事人信息正常！')
          }
        }
      })
    },

    // 搜索条件省市区接口
    getCity(data, name) {
      let area
      const dataObj = {}
      if (data.length != 0) {
        if (data.length == 1) {
          dataObj.province = data[0].value
          dataObj.city = ''
          dataObj.area = ''
          area = data[0].label
        } else if (data.length == 2) {
          dataObj.province = data[0].value
          dataObj.city = data[1].value
          dataObj.area = ''
          area = data[0].label + data[1].label
        } else if (data.length == 3) {
          dataObj.province = data[0].value
          dataObj.city = data[1].value
          dataObj.area = data[2].value
          area = data[0].label + data[1].label + data[2].label
        }
      } else {
        dataObj.province = ''
        dataObj.city = ''
        dataObj.area = ''
        area = ''
      }
      this.tortSubjectObj.province = dataObj.province
      this.tortSubjectObj.city = dataObj.city
      this.tortSubjectObj.area = dataObj.area
    },
    giveData() {
      this.tortSubjectObj.category = this.defaultData.category
      this.tortSubjectObj.name = this.defaultData.name
      this.tortSubjectObj.creditCode = this.defaultData.creditCode
        ? this.defaultData.creditCode.trim()
        : ''
      this.tortSubjectObj.platformOrderNo = this.defaultData.platformOrderNo
        ? this.defaultData.platformOrderNo.trim()
        : ''
      this.tortSubjectObj.legalIdNo = this.defaultData.legalIdNo
      this.tortSubjectObj.legalRepresentative = this.defaultData.legalRepresentative
      this.tortSubjectObj.contact = this.defaultData.contact
      this.tortSubjectObj.cityList = this.defaultData.cityList
      this.tortSubjectObj.address = this.defaultData.address
      this.tortSubjectObj.province = this.defaultData.province
      this.tortSubjectObj.city = this.defaultData.city
      this.tortSubjectObj.area = this.defaultData.area
      this.tortSubjectObj.attachmentList = this.defaultData.attachmentList
      this.tortSubjectObj.identifyRemark = this.defaultData.identifyRemark
      if (this.tortSubjectObj.category === 'S') {
        this.tortSubjectObj.type = this.defaultData.type
      }
      // 这两行之前是放在上面的if判断中的，现在改到这里是为了让修改的时候，能正常显示生产商法定代表人和身份证号
      // 至于会不会带来其他影响，尚未可知，litigant.vue的submitNew方法中，限制了category === 'S'时，才提交
      // type 和 property，所以感觉应该也不会有什么问题
      this.tortSubjectObj.property = this.defaultData.property
      this.initProperty = this.defaultData.property
      console.log(' this.tortSubjectObj.property', this.tortSubjectObj.property)
      if (this.defaultData.id) {
        this.tortSubjectObj.id = this.defaultData.id
      }

      this.isDetailLoad = true
    },
    // 手动验证 传值
    submitValid() {
      let flag
      this.$refs['formData'].validate(valid => {
        flag = valid
        this.$emit('getList', this.tortSubjectObj)
      })
      return flag
    },
    changeCategory(type) {
      if (type === 'M' && (!this.defaultData.category || this.defaultData.property == 'P')) {
        this.tortSubjectObj.property = 'E'
      } else {
        this.initProperty ? this.tortSubjectObj.property = this.initProperty : this.tortSubjectObj.property = 'P'
      }
    },
    // 依据图片
    getAttachmentList(arr) {
      this.tortSubjectObj['attachmentList'] = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        if (item.id) {
          obj.id = item.id
        }
        this.tortSubjectObj['attachmentList'].push(obj)
      })
    },
    // 数据字典
    async getDictionary() {
      this.tortSubjCategoryArr = await this.common.getDictionaryItems(
        'tort_subj_category'
      )
      this.tortSubjPropertyArr = await this.common.getDictionaryItems(
        'tort_subj_property'
      )
      this.tortSubjPropertyProducerArr = this.tortSubjPropertyArr.filter(item => item.value != 'P')
      this.tortSubjTypeArr = await this.common.getDictionaryItems(
        'tort_subj_type'
      )
    }
  }
}
</script>
<style lang="scss" scoped>
.warn {
  position: absolute;
  bottom: -27px;
  left: 7px;
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/view/clue/myClue/plugin/tortSubjectForm.vue